module.exports = __webpack_public_path__ + "static/img/res.1a978c43.png";